var fn = function( obj ){
var __t,__p='';
__p+='\n#if __VERSION__ == 300\n  #define IN in\n  #define texture2D(a,b) texture( a, b )\n#else\n  #define IN varying\n  #define FragColor gl_FragColor\n#endif\n\n\n\n#if __VERSION__ == 300\n  out vec4 FragColor;\n#endif\n\n\n\n//                MAIN\n// ===================\n\nvoid main( void ){\n\n\n  FragColor = vec4(0.5, 0.5, 0., 1.);\n\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;